export default class CartOption {
  constructor({ code, id, name, price, min = null, max = null, required = false, computedPrice = null, value = null, values = null, selection = []  }) { 
    this.code = code;
    this.id = id;
    this.name = name;
    this.price = price;
    this.min = min;
    this.max = max;
    this.required = required;
    this.computedPrice = computedPrice;
    this.values = values;
    this.value = value;
    this.selection = selection;
  }

  get total() { 
    let ret = 0;

    if(this.selection instanceof Object) {
      if(this.values instanceof Array) {
        let addBasePrice = false;
        this.values.forEach(v => {
          if(![false, null, 0].includes(this.selection[v.code])) {
            addBasePrice = true;
            let p = v.variationPrice;

            if(typeof this.selection[v.code] === 'number') {
              p = p * this.selection[v.code];
            }

            ret += p;
          }
        });

        if(addBasePrice) {
          ret += this.price;
        }
      }
    } else {
      if(![null, false].includes(this.selection)) {
        if(typeof this.selection === "string") {
          if(typeof this.value === 'string') {
            ret += this.price;
          } else {
            ret += this.price + this.values.find(v => v.code === this.selection).variationPrice;
          }
        } else {
          ret += this.price;
        }
      }
    }

    return ret;
  }

  toCheckout() {
    return {
      option_id: this.id,
      selection: this.selection,
    }
  }

  toString() { 
    let ret = null;

    if(this.selection instanceof Object) {
      Object.keys(this.selection).forEach(key => {
        if(![null, false, 0].includes(this.selection[key]) && ret === null) {
          ret = this.name;
        }
      });
    } else {
      if(![null, false].includes(this.selection)) {
        ret = this.name;
      }
    }
    return ret;
  }

  toStringNew() {
    let ret = null;

    if(this.selection instanceof Object && this.price !== undefined) {
      Object.keys(this.selection).forEach((key, i) => {
        if(![null, false, 0].includes(this.selection[key])) {
          if(ret === null) {
            ret = '';
          }

          if(ret !== '' && i < (Object.keys(this.selection).length - 1)) {
            ret += ', ';
          }

          ret += `${key}`;
          
          if(typeof this.selection[key] === 'number' && this.selection[key] > 1) {
            ret += ` x${this.selection[key]}`;
          }
        }
      });
    } else {
      if(![null, false].includes(this.selection) && this.price !== undefined) {
        ret = this.name;
      }
    }
    return ret;
  }

  validate() {
    let ret = true;
    
    if(this.required) {
      if(this.selection instanceof Object) {
        let selected = 0;
        Object.keys(this.selection).forEach(key => {
          if(typeof this.selection[key] === 'number') {
            selected += this.selection[key];
          } else {
            selected++;
          }
        });
        ret = (selected >= this.min) && (selected <= this.max);
      } else {
        ret = !(this.selection === null);
      }
    } 

    return ret;
  }

  static fromJSON(json) {
    return {
      code: json.code,
      id: json.option_id,
      name: json.title_locale,
      price: json.price,
      value: json.value,
      selection: json.selection
    };
  }
}